<template>
<div class="list-page" v-loading="pageLoading">
  <van-nav-bar ref="nav" :border="false" @click-left="back" placeholder :fixed="true" title="课程分类">
    <template #left>
      <van-icon size="20px" name="arrow-left" color="#333" />
    </template>
  </van-nav-bar>
  <SubHeader></SubHeader>
  <div class="content" v-if="classify.length">
    <div class="classify">
      <div class="classify-item ellipsis" @click="onClickClassify(index)" :class="index == active ? 'classify-item_active' : ''" v-for="(item, index) of classify" :key="item.category_id">
        {{ item.category_name }}
      </div>
    </div>
    <div class="list">
      <div class="list-name ellipsis">
        {{ classify[active].category_name }}
      </div>
      <div class="scroll-content" v-loading="listLoading">
        <template v-for="(item, index) of classify" >
          <van-list v-show="index == active" :key="item.category_id" v-model="item.loading" :finished="item.finished" finished-text="没有更多了" :immediate-check="false" @load="loadmore">
            <SmallPriceCard v-for="card of item.list" :key="card.id" :cardData="card" class="card"></SmallPriceCard>
          </van-list>
        </template>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import SubHeader from "@/components/SubHeader";
import SmallPriceCard from "@/components/SmallPriceCard";
export default {
  components: {
    SubHeader,
    SmallPriceCard,
  },
  computed: {
    partalName() {
      return this.$store.state.partal.name;
    },
  },
  data() {
    return {
      pageLoading: true,
      listLoading: true,
      showUser: false,
      active: 0,
      classify: [],
      limit: 10,
      // navHeight: 46
    };
  },
  async mounted() {
    await this.init();
    this.pageLoading = false;
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    onClickClassify(value) {
      this.active = value;
      this.getList();
    },
    async init() {
      let res = await this.$api({
        url: "/api/users/university/index",
      });
      if (res.code == 0) {
        res.data.category.forEach((e, i) => {
          if (e.category_id == this.$route.query.id) {
            this.active = i;
          }
          e.list = [];
          e.page = 1;
          e.loading = false;
          e.finished = false;
        });
        this.classify = res.data.category;
        this.getList();

      } else {
        this.$toast(res.msg)
      }
    },
    async getList() {
      this.listLoading = true;
      let target = this.classify[this.active];
      if (target.list.length) {
        return;
      }
      target.page = 1;
      target.list = [];

      let res = await this.$api({
        url: "/api/users/university/goodsList",
        data: {
          category_id: target.category_id,
          page: target.page,
          limit: this.limit,
        },
      });
      this.listLoading = false;
      if (res.code == 0) {
        target.list = res.data.list;
        if (res.data.list.length < this.limit) {
          target.finished = true;
          target.loading = false;
        }
      }
    },
    async loadmore() {
      let target = this.classify[this.active];
      if (target.finished) {
        return;
      }
      target.page += 1;
      let res = await this.$api({
        url: "/api/users/university/goodsList",
        data: {
          category_id: target.category_id,
          page: target.page,
          limit: this.limit,
        },
      });
      if (res.code == 0) {
        target.list = target.list.concat(res.data.list);
        if (res.data.list.length < this.limit) {
          target.finished = true;
          target.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.list-page {
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}

.content {
  height: calc(100vh - 96px - 88px);
  flex: 0 1 auto;
  width: 100%;
  display: flex;
  box-sizing: border-box;
}

.classify {
  flex: 0 0 172px;
  height: 100%;
  width: 172px;
  box-sizing: border-box;
}

.list {
  flex: 0 1 auto;
  height: calc(100%);
  width: 100%;
  background: #f7f8fa;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 0 20px;
  box-sizing: border-box;
}

.classify-item {
  width: 142px;
  height: 50px;
  border-radius: 31px;
  color: #333;
  font-size: 26px;
  line-height: 50px;
  padding: 0 10px;
  box-sizing: border-box;
  margin: 45px auto;
  text-align: center;
}

.classify-item_active {
  width: 142px;
  height: 50px;
  background: #a7090a;
  border-radius: 31px;
  color: #fff;
}

.list-name {
  height: 89px;
  line-height: 89px;
  color: #333;
  font-size: 34px;
  width: 538px;
}

.scroll-content {
  height: calc(100% - 89px);
  background: #fff;
  overflow: hidden;
  border-radius: 12px;
  border-radius: 1px solid #eee;
  width: 100%;
}

.classify-item:last-of-type,
.card:last-of-type {
  margin-bottom: 100px;
}
</style>
